import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import App from './App.vue'
import { useCookies } from 'vue3-cookies'
import 'element-plus/dist/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import router from './components/router/index'
import store from './components/store/store'
import 'dayjs/locale/ru'
import ru from 'element-plus/es/locale/lang/ru'
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import dayjs from 'dayjs'
import '@/assets/theme.css'
import '@/assets/appointment-modal.css'

library.add(fas, far, fab);

dayjs.locale({
  ...dayjs.Ls.ru,
  weekStart: 1
})

createApp(App)
  .use(ElementPlus, {
    locale: ru
  })
  .use(useCookies)
  .use(VueTelInput)
  .use(router)
  .use(store)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app')
